<div dir="rtl" class="bg-light" style="height: 100%; padding: 5px" *ngIf="statement">
  <br>
  <br>
  <div class="d-flex justify-content-between px-4">
    <div style="align-self: center;">
      <h5>
        لتداول الاوراق المالية
      </h5>
    </div>
    <div style="max-width: 8%;">
      <img src="./assets/img/logo.png">
    </div>
  </div>
  <br>
  <div class="text-center">
    <h2>كشف حساب عميل</h2>
  </div>
  <br>
  <hr>
  <div class="mx-2 subpage">
    <div class="p-3">
      <mark class="row mx-1 px-2 justify-content-center mb-4">
        <div class="col-3 d-flex justify-content-around  p-2">
          <div>
            <strong>اسم العميل: </strong>
          </div>
          <div>
            {{statement.clientName}}
          </div>
        </div>
        <div class="col-3 d-flex justify-content-around  p-2">
          <div>
            <strong>كود التداول:</strong>
          </div>
          <div>
            {{statement.ExchangeCode}}
          </div>
        </div>
        <div class="col-3 d-flex justify-content-around  p-2">
          <div>
            <strong>كود العميل:</strong>
          </div>
          <div>
            {{statement.RelationCode}}
          </div>
        </div>

        <div class="col-3 d-flex justify-content-around  p-2">
          <div>
            <strong>الكود الموحد:</strong>
          </div>
          <div>
            {{statement.UnifiedCode}}
          </div>
        </div>

      </mark>

      <div class="row mx-1">
        <div class="col-3 d-flex justify-content-around" style="text-align: start;">
          <div>
            <strong>العملة: </strong>
          </div>
          <div>
            {{statement.MasterCurrencyClientStatements[0].CurrencyName}}
          </div>
        </div>
        <div class="col-3 d-flex justify-content-around" style="text-align: start;">
          <div>
            <strong>رصيد اول المدة:</strong>
          </div>
          <div>
            {{statement.MasterCurrencyClientStatements[0].BeginingBalance}}
            {{statement.MasterCurrencyClientStatements[0].BeginingBalanceName}}
          </div>
        </div>
        <div class="col-3 d-flex justify-content-around" style="text-align: start;">
          <div>
            <strong>رصيد اخر المدة:</strong>
          </div>
          <div>
            {{statement.MasterCurrencyClientStatements[0].EndingBalanceValue}}
            {{statement.MasterCurrencyClientStatements[0].EndingBalanceName}}
          </div>
        </div>
        <!-- <div class="col-3 d-flex justify-content-around" style="text-align: start;">
          <div>
            <strong>رصيد اخر المدة:</strong>
          </div>
          <div>
            {{statement.MasterCurrencyClientStatements[0].EndingBalanceValue}}
            {{statement.MasterCurrencyClientStatements[0].EndingBalanceName}}
          </div>
        </div> -->
      </div>
    </div>
    <div class="mt-4">
      <table class="table table-sm" style="max-height: 400px !important;">
        <thead>
          <tr>
            <td class="fit"><strong>حق اليوم</strong></td>
            <td class="fit"><strong>رقم القيد</strong></td>
            <!-- <td class="fit">رقم المستند</td> -->
            <td class="fit"><strong>نوع الحركة</strong></td>
            <td class="fit"><strong>الوصف</strong></td>
            <!-- <td class="fit">التاريخ</td> -->
            <td class="fit"><strong>مدين</strong></td>
            <td class="fit"><strong>دائن</strong></td>
            <td class="fit"><strong>رصيد</strong></td>
            <td class="fit"></td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let statement of statement.MasterCurrencyClientStatements[0].detailClientStatements">
            <td class="fit">{{statement.BatchDate}}</td>
            <td class="fit">{{statement.PostedSerial}}</td>
            <!-- <td class="fit">{{statement.JournalId}}</td> -->
            <td class="fit">{{statement.DocumentSource}}</td>
            <td class="desc">{{statement.DetailDescE}}</td>
            <!-- <td class="fit">{{statement.BatchDate}}</td> -->
            <td class="fit">{{statement.DebitAmount}}</td>
            <td class="fit">{{statement.CreditAmount}}</td>
            <td class="fit">{{statement.BalanceValue}}</td>
            <td class="fit">{{statement.BalanceName}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="fit">
              <h6>{{'total'|translate}}</h6>
            </td>
            <td class="fit"></td>
            <td class="fit"></td>
            <td class="fit"></td>
          </tr>
        </tfoot>
      </table>
      <div>
        {{statement.MasterCurrencyClientStatements[0].EndingBalanceValue}}
        {{statement.MasterCurrencyClientStatements[0].EndingBalanceName}}
      </div>
    </div>
    <hr>
    <br>
    <div class="row mx-5">
      <small class="col-12" style="text-align: start;">
        اقر انا الموقع ادناه انني اوافق واصادق علي صحه رصيد حسابي وعلي كافه الاوامر وعمليات البيع والشراء والخصم والاضافه والايداع والسحب سواء نقديه او بشيكات والتحويلات والعمولات والمصروفات والرسوم التي تمت بحسابي طرف شركه الاقصر
        لتداول الاوراق المالية بتك العمليات واقر انها تمت بناء علي تعليماتي باوامر شخصيه مباشره مني واقر باستلامي كشوف الحساب واخطارات التنفيذ عن الفتره من بدايه تعاملي مع الشركه حتي تاريخه واوافق علي جميع التسجيلات الهاتفيه والكتابيه لاوامري حتي
        تاريخه ولا يحق لي الرجوع علي الشركه باي مستندات او ادله اخري بخلاف هذا الاقرار او مطالبه الشركه بمستندات اخري بخصوص معاملاتي قبل تاريخ هذا الاقرار
      </small>
    </div>
    <hr>


  </div>

  <div class="divFooter" style="bottom:15px;position: absolute; width: 100%;">
    <div class="row m-0">
      <div class="col-4 d-flex justify-content-around">
        <div>طبع بواسطة</div>
        <div>{{profile.SubNameA}}</div>
      </div>
      <div class="col-4 d-flex justify-content-around">
      </div>
      <div class="col-4 d-flex justify-content-around">
        <div>تاريخ الطباعة</div>
        <div>{{today |date:'medium'}}</div>
      </div>
    </div>
  </div>

</div>
